<script setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const props = defineProps({
  value: [String, Number],
  name: String,
  error: Boolean,
  items: Array,
  template: String,
  multiple: Boolean
});

const emit = defineEmits(["update:modelValue"]);
function itemSelected(event){
    emit("update:modelValue", event.target.value);
}


</script>

<template>
    <select 
        class="customSelect"
        :class="[props.error ? 'error' : '']"
        :value="props.value" 
        :name="props.name"
        :error="props.error"
        :multiple="props.multiple"
        @change="itemSelected($event)">
            <option
                v-for="(item, i) in items"
                :key="item.id"
                :value="item.id"
                
                :selected="item.id === props.value?.id"
            >
            <span v-if="props.template == 1">{{ item.name }}</span>
            <span v-if="props.template == 2">{{ item.firstname + ' ' + item.lastname + ' - ' + t('vehicle.client_type.'+item.vehicle_client_type)  }}</span>
                
            </option>
    </select>
</template>

<style lang="scss" scoped>
.customSelect {
  width: 100%;
  line-height: 1.25 !important;
  border-radius: 50px;
  border: 1px solid #e2e8f0;
  background-color: white !important;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  color: #707070;
  font-family: 'CircularStd-Book';
  &.error {
    border: 1px solid #FF9999;
  }
}

.customSelect:focus {
  outline: none;
}

.customSelect:disabled {
  background-color: #f7f7f7 !important;
  color: #808080;
  opacity: 1;
}
</style>
